import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import * as React from "react";
import "./index.scss";
const Root = styled("div")(({ theme }) => ({
  width: "100%",
  ...theme.typography.body2,
  "& > :not(style) + :not(style)": {
    marginTop: theme.spacing(2),
  },
}));

export default function DividerComponent(text) {
  return (
    <Root>
      <Divider>OR</Divider>
    </Root>
  );
}
